module.exports = __webpack_public_path__ + "img/bg.adf8e494.png";